<div class="row g-2 mx-2 pb-3">
  <div class="ace-h2">Datos de la incidencia</div>
  <div class="col-2">
    <div class="example-form">
      <label class="form-label mb-0">Inicio del periodo</label>
      <input type="date" [(ngModel)]="inicioPersonalizado" (change)="onInicioChange()" class="form-control">
    </div>
  </div>

  <div class="col-2">
    <div class="example-form">
      <label class="form-label mb-0">Terminación del periodo</label>
      <input type="date" [(ngModel)]="finPersonalizado" (change)="calcularDias()" class="form-control">
    </div>
  </div>

  <div class="col-2">
    <div class="example-form">
      <label class="form-label mb-0">Días</label>
      <input type="number" [(ngModel)]="diasPeriodo" class="form-control bg-light" readonly>
    </div>
  </div>

  <div class="col-3">
    <label class="mb-0 text-start">Filtrar por {{ etiquetaAgrupar }}</label>
    <ng-select [items]="grupoEmpleados" [(ngModel)]="agrupadoresSeleccionados" (ngModelChange)="areasSeleccionadas = []; aplicarFiltros()" [multiple]="true" [virtualScroll]="true" [closeOnSelect]="false" notFoundText="Agrupador no encontrado" placeholder="Selecciona el agrupador" appendTo="body" dropdownPosition="auto">
    </ng-select>
  </div>

  <div class="col-3">
    <label class="mb-0 text-start">Filtrar por área</label>
    <ng-select [items]="areasEmpleados" [(ngModel)]="areasSeleccionadas" (ngModelChange)="agrupadoresSeleccionados = []; aplicarFiltros()" [multiple]="true" [virtualScroll]="true" [closeOnSelect]="false" notFoundText="Área no encontrada" placeholder="Selecciona el área" appendTo="body" dropdownPosition="auto">
    </ng-select>
  </div>

  <div class="col-4">
    <label class="form-label mb-0">Tipo de movimiento</label>
    <select class="form-select form-select-sm" aria-label="Default select example" [(ngModel)]="nuevaIncidencia.tipoManejoIncidencia">
      <option *ngFor="let movimiento of tipoManejoIncidencia | keyvalue: valueTipoIncidenciaAscOrder" [value]="movimiento.key">
        {{ movimiento.value }}
      </option>
    </select>
  </div>

  <div class="col-4" *ngIf="nuevaIncidencia.tipoManejoIncidencia == 3">
    <label class="form-label mb-0">Tipo de incapacidad</label>
    <select class="form-select form-select-sm" aria-label="Default select example" [(ngModel)]="nuevaIncidencia.tipoIncapacidad">
      <option *ngFor="let incapacidad of tipoIncapacidad | keyvalue" [value]="incapacidad.key">
        {{ incapacidad.value }}
      </option>
    </select>
  </div>

  <div class="col-4" *ngIf="nuevaIncidencia.tipoManejoIncidencia == 3">
    <label class="form-label mb-0">Folio incapacidad</label>
    <input type="text" placeholder="Folio incapacidad" [(ngModel)]="nuevaIncidencia.observaciones" class="form-control form-select-sm">
  </div>

  <div class="col-8 mb-2" *ngIf="nuevaIncidencia.tipoManejoIncidencia != 3">
    <label class="form-label mb-0">Observaciones</label>
    <input type="text" placeholder="Observaciones" [(ngModel)]="nuevaIncidencia.observaciones" class="form-control form-select-sm">
  </div>

  <hr class="bg-body-tertiary mb-0">

  <div class="ace-h2 mt-2">Excluir empleados</div>
  <div class="col-4">
    <label class="mb-0 text-start">Excluir empleados</label>
    <ng-select
      [items]="empleados"
      [(ngModel)]="empleadosExcluidosSeleccionados"
      bindLabel="nombreCompleto"
      [multiple]="true"
      [virtualScroll]="true"
      [closeOnSelect]="false"
      (ngModelChange)="excluirEmpleados(empleadosExcluidosSeleccionados, areasExcluidasSeleccionadas, agrupadoresExcluidosSeleccionados)"
      notFoundText="Empleado no encontrado"
      placeholder="Seleccionar empleados"
      appendTo="body"
      dropdownPosition="auto">
      <ng-template ng-option-tmp let-item="item">
        {{ nombreCompleto(item) }}
      </ng-template>
    </ng-select>
  </div>

  <div class="col-4">
    <label class="mb-0 text-start">Excluir áreas</label>
    <ng-select
      [items]="areasEmpleados"
      [(ngModel)]="areasExcluidasSeleccionadas"
      [multiple]="true"
      [virtualScroll]="true"
      [closeOnSelect]="false"
      (ngModelChange)="excluirEmpleados(empleadosExcluidosSeleccionados, areasExcluidasSeleccionadas, agrupadoresExcluidosSeleccionados)"
      notFoundText="Área no encontrada"
      placeholder="Seleccionar áreas"
      appendTo="body"
      dropdownPosition="auto">
    </ng-select>
  </div>

  <div class="col-4">
    <label class="mb-0 text-start">Excluir {{ etiquetaAgrupar }}</label>
    <ng-select
      [items]="grupoEmpleados"
      [(ngModel)]="agrupadoresExcluidosSeleccionados"
      [multiple]="true"
      [virtualScroll]="true"
      [closeOnSelect]="false"
      (ngModelChange)="excluirEmpleados(empleadosExcluidosSeleccionados, areasExcluidasSeleccionadas, agrupadoresExcluidosSeleccionados)"
      notFoundText="Grupo no encontrado"
      placeholder="Seleccionar agrupadores"
      appendTo="body"
      dropdownPosition="auto">
    </ng-select>
  </div>

  <div class="col-12 row g-2 align-items-end justify-content-end" *ngIf="!estaCargando">
    <!-- <div class="col-3">
      <label class="form-label mb-0">Ordenar por</label>
      <select class="form-select" aria-label="Default select example" [(ngModel)]="selectedAcomodo" (ngModelChange)="aplicarFiltros()">
        <option *ngFor="let opcion of opcionesFiltrosAcomodo | keyvalue" [value]="opcion.key">
          {{ opcion.value }}
        </option>
      </select>
    </div> -->
    <div class="d-flex justify-content-end gap-2">
      <button mat-raised-button class="bg-success text-white" (click)="guardarIncidenciasMasivas()">
        <mat-icon>save</mat-icon>Guardar incidencias
      </button>
      <button mat-raised-button class="bg-danger text-white" (click)="cerrarIncidencias()">Cancelar</button>
    </div>
  </div>
</div>

<div *ngIf="estaCargando">
  <div class="text-center py-5">
    <mat-spinner class="img-center"></mat-spinner>
  </div>
  <div class="text-center">
    <span>Cargando datos...</span>
  </div>
</div>

<div class="mat-elevation-z8 col-11 mx-auto" *ngIf="!estaCargando">
  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? toggleAllRows() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      [aria-label]="checkboxLabel()"
                      color="primary">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)"
                      [aria-label]="checkboxLabel(row)"
                      color="primary">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="clave">
      <th mat-header-cell *matHeaderCellDef>Clave</th>
      <td mat-cell *matCellDef="let empleado"> {{empleado.numero}} </td>
    </ng-container>

    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let empleado"> {{nombreCompleto(empleado)}} </td>
    </ng-container>

    <ng-container matColumnDef="rfc">
      <th mat-header-cell *matHeaderCellDef>R.F.C.</th>
      <td mat-cell *matCellDef="let empleado"> {{empleado.rfc}} </td>
    </ng-container>

    <ng-container matColumnDef="alta">
      <th mat-header-cell *matHeaderCellDef>Alta</th>
      <td mat-cell *matCellDef="let empleado"> {{formatoFechaCorto(empleado.altaActualTxt)}} </td>
    </ng-container>

    <ng-container matColumnDef="baja" *ngIf="mostrarBajas">
      <th mat-header-cell *matHeaderCellDef>Baja</th>
      <td mat-cell *matCellDef="let empleado"> {{formatoFechaCorto(empleado.bajaActualTxt)}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        (click)="selection.toggle(row)">
    </tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="6">No hay empleados encontrados con los filtros seleccionados</td>
    </tr>
  </table>
</div>

<div class="d-flex justify-content-start mt-3" *ngIf="!estaCargando && empleados.length > 0">
  <div class="form-check mx-2">
    <input class="form-check-input" type="checkbox" id="mostrarBajasValidar" [(ngModel)]="mostrarBajas" (change)="aplicarFiltros()">
    <label class="form-check-label fw-bold" for="mostrarBajasValidar">Mostrar empleados dados de baja</label>
  </div>
</div>
